import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Heading } from 'src/components/Heading';
import { Tab } from 'src/components/Tab';
import { AutomationsTab } from './components/AutomationsTab';
import { AutomationsHistoryTab } from './components/AutomationsHistoryTab';
import { Can, Subject } from 'src/hooks/usePermissions';

export const Automations = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = useMemo(
    () => [
      { label: 'Manage', content: <AutomationsTab />, paramValue: 'manage' },
      {
        label: 'Monitor',
        content: <AutomationsHistoryTab />,
        paramValue: 'monitor',
      },
    ],
    [],
  );

  const [activeTabIndex, setActiveTabIndex] = useState(() => {
    const param = searchParams.get('tab');
    const idx = param ? tabs.findIndex((t) => t.paramValue === param) : 0;
    return idx === -1 ? 0 : idx;
  });

  useEffect(() => {
    const param = searchParams.get('tab');
    const idx = param ? tabs.findIndex((t) => t.paramValue === param) : 0;

    // If the URL is invalid, fix it; otherwise sync local state.
    if (idx === -1) {
      setSearchParams({ tab: tabs[0].paramValue }, { replace: true });
      setActiveTabIndex(0);
    } else if (idx !== activeTabIndex) {
      setActiveTabIndex(idx);
    }
  }, [searchParams, tabs, activeTabIndex, setSearchParams]);

  const handleTabChange = (i: number) => {
    if (i === activeTabIndex) return; // nothing to do
    setActiveTabIndex(i);
    setSearchParams({ tab: tabs[i].paramValue }, { replace: true });
  };

  return (
    <>
      <Heading
        title="Campaigns"
        subtitle="Set up campaigns to automate messages and calls."
        className="border-b-0"
      />

      <Can operation="read" subject={Subject.CAMPAIGNS}>
        {/* Render only when index is known (always true after first render) */}
        {activeTabIndex !== undefined && (
          <Tab
            className="pl-2"
            items={tabs}
            selectedIndex={activeTabIndex}
            onChange={handleTabChange}
            panelWrapperClassName="mt-0"
          />
        )}
      </Can>
    </>
  );
};
